import { BrowserRouter as Router, Routes, Route, unstable_HistoryRouter as HistoryRouter, Navigate, useNavigate, useLocation, Outlet } from "react-router-dom";

import VendorLayout from "routes/vendor/VendorLayout";
import VendorOrderRequest from "routes/vendor/VendorOrderRequest";
import VendorSalesSettlement from "routes/vendor/VendorSalesSettlement";
import VendorSalesStatistics from "routes/vendor/VendorSalesStatistics";
import VendorInventoryControll from "routes/vendor/inventory/VendorInventoryControll";
import VendorStoreDetail from "routes/vendor/storemanage/pages/VendorStoreDetail";
import VendorStoreManage from "routes/vendor/storemanage/pages/VendorStoreManage";

import VendorMainLayout from "routes/vendorRe/layouts/VendorMainLayout";
import MobileVendotStoreDetail from "routes/vendorRe/pages/MobileVendotStoreDetail";
import VendorApp from "routes/vendorRe/pages/VendorApp";
import VendorCalc from "routes/vendorRe/pages/VendorCalc";
import VendorCctv from "routes/vendorRe/pages/VendorCctv";
import VendorComplete from "routes/vendorRe/pages/VendorComplete";
import VendorDevice from "routes/vendorRe/pages/VendorDevice";
import VendorError from "routes/vendorRe/pages/VendorError";
import VendorInfo from "routes/vendorRe/pages/VendorInfo";
import VendorSale from "routes/vendorRe/pages/VendorSale";
import VendorStats from "routes/vendorRe/pages/VendorStats";
import VendorStoreManagement from "routes/vendorRe/pages/VendorStoreManagement";
import VendotStoreDetail from "routes/vendorRe/pages/VendotStoreDetail";

import RequireAuth from "shared/utils/RequireAuth";

function VendorRouter({ allowedRoles }) {
    return (
        <Routes>
            <Route path="" element={<RequireAuth allowedRoles={allowedRoles} />}>
                <Route path="" element={<VendorLayout />}>
                    <Route path="sales" element={<VendorSalesStatistics />} />
                    <Route path="inventory" element={<VendorInventoryControll />} />
                    <Route path="orderRequest" element={<VendorOrderRequest />} />
                    <Route path="settlement" element={<VendorSalesSettlement />} />
                    <Route path="salesStatistics" element={<VendorSalesStatistics />} />
                    <Route path="storeManagement" element={<VendorStoreManagement />} />
                    <Route path={"storeManagement/detail/:storeId"} element={<VendotStoreDetail />} />
                    {/* 매장 관리 */}
                    <Route path="storeManage" element={<VendorStoreManage />} />
                    <Route path="storeDetail/:storeNo" element={<VendorStoreDetail />} />
                    <Route path="sale" element={<VendorSale />} />
                    <Route path="store/sale/:storeId" element={<VendorSale />} />
                </Route>

                {/* 이건정 라우터 추가 */}
                <Route path="start" element={<VendorApp />} />
                <Route path="main" element={<VendorMainLayout />}>
                    {/* 관리자 메인 화면 */}
                    <Route path="" element={<VendorInfo />} />
                    <Route path={"detail/:storeId"} element={<MobileVendotStoreDetail />} />
                    <Route path="store/sale/:storeId" element={<VendorSale />} />
                    {/* 관리자 매출, 판매 통계 */}
                    <Route path="stats" element={<VendorStats />} />
                    {/* 관리자 정산 금액 조회 */}
                    <Route path="calc" element={<VendorCalc />} />
                    {/* 관리자 판매 내역 조회 */}
                    <Route path="sale" element={<VendorSale />} />
                    {/* 관리자 매장 기기 관리 */}
                    <Route path="device" element={<VendorDevice />} />
                    {/* 관리자 오류 접수 */}
                    {/* <Route path="error" element={<VendorError />} /> */}
                    {/* 관리자 접수 완료 */}
                    <Route path="complete" element={<VendorComplete />} />
                    {/* 관리자 CCTV */}
                    <Route path="cctv" element={<VendorCctv />} />
                </Route>
            </Route>
        </Routes>
    );
}

export default VendorRouter;